import React, { Component } from "react";
import { Link } from "react-router-dom";
import { NavHashLink as NavLink } from "react-router-hash-link";
import ScrollEvent from "react-onscroll";

import s from "./Menu.scss";

export default class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    /*     window.addEventListener('scroll', () => {
      let currentOffset = window.scrollY; 
       let currentOffset = window.pageYOffset; 
       let val = "";
       
      let idsArray = ["roof", "main", "foundations", "contact"];
      let elementsArr = idsArray.map(element => {  
        if(element == "contact"){
          return {
            value: this.getTopOffset(document.querySelector(`#${element}`)) - window.screen.height,
            name: element
          }
        } else {
          return {
            value: this.getTopOffset(document.querySelector(`#${element}`)),
            name: element
          }    
        }
        
      })   
      
      for (let i = elementsArr.length -1 ; i >= 0 ; i--) {
        if(elementsArr[i].value <= currentOffset){
         val = elementsArr[i].name;
          break;
        }
        
      }
      this.setState({activeSection: val})
     
    }) */
  }
  getTopOffset = element => {
    let position = 0;
    if (element.offsetParent) {
      do {
        position += element.offsetTop;
        element = element.offsetParent;
      } while (element);
    }
    return position >= 0 ? position : 0;
  };
  hideMenu() {
    this.props.closeMenu();
  }

  scrollWithOffset = (el, offset, activeSection) => {
    const elementPosition = el.offsetTop - offset;
    if (typeof window !== "undefined") {
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth"
      });
    }
  };

  render() {
    return (
      <div className={"menu-container" + (this.props.menu ? " active" : "")}>
        <div className="menu">
          <button
            onClick={this.hideMenu.bind(this)}
            className="cross-icon text-basic"
          >
            <span className="af-icon-cross "></span>
          </button>
          <div className="links-container">
            <ul>
            <li>
                <NavLink
                  onClick={e => {
                    if (window.location.pathname == "/") {
                      e.preventDefault();
                    }
                    this.hideMenu();
                  }}
                  className={
                    "link" 
                  }
                  to={"/"}
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  smooth
                  scroll={el => {
                    this.scrollWithOffset(el, 178, "roof");
                  }}
                  onClick={e => {
                    if (window.location.pathname == "/dach") {
                      e.preventDefault();
                    }
                    this.hideMenu();
                  }}
                  className={
                    "link" 
                  }
                  to={"/dach"}
                >
                  Dach
                </NavLink>
              </li>

              <li>
                <NavLink
                  smooth
                  scroll={el => {
                    this.scrollWithOffset(el, 0, "foundations");
                  }}
                 
                  className={
                    "link"
                  }
                  to={"/fundamenty"}
                >
                  Fundament
                </NavLink>
              </li>
              {/*               <li>
                <NavLink
                  smooth
                  scroll={el => {
                    this.scrollWithOffset(el, 0, "start");
                  }}
                  onClick={e => {
                    if (window.location.pathname == "/") {
                      e.preventDefault();
                    }
                    this.hideMenu();
                  }}
                  className={
                    "link" +
                    (this.state.activeSection == "main" ? " active" : "")
                  }
                  to={"/#main"}
                >
                  Start
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to={"/dach/#kontakt"}
                  smooth
                  scroll={el => this.scrollWithOffset(el, 500, "kontakt")}
                  onClick={e => {
                    if (window.location.pathname == "/dach/#kontakt") {
                      e.preventDefault();
                    }
                    this.hideMenu();
                  }}
                  className={
                    "link" 
                  }
                >
                  Kontakt
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js